import { FormControlLabel, Switch, SwitchProps, styled } from "@mui/material";
import * as React from "react";

declare const window: any;

export default function ContactModalContainer({
  theme,
  colors,
  isContactModal,
  setIsContactModal,
  builderLogo,
  projectLogo,
  data,
  projectLogosMultiples,
  active_builder_logo,
  logo_invertido
}: any) {
  React.useEffect(() => {
    const m_contact: any = document.querySelector(".contacto-modal");

    if (m_contact) {
      if (isContactModal) {
        m_contact.style.display = "grid";
      } else {
        setTimeout(() => {
          m_contact.style.display = "none";
        }, 510);
      }
    }
  }, [isContactModal]);

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  return (
    <div
      className={`contacto-modal ${theme} ${isContactModal ? "show" : ""} `}
      style={{ zIndex: isContactModal ? 10 : 0 }}
    >
      <div className="contacto-modal-close">
        <i
          className="fas fa-xmark"
          onClick={() => setIsContactModal(false)}
        ></i>
      </div>

      <div className="contacto-modal-row">
        <div className="contacto-modal-col-left" style={projectLogosMultiples.length > 0 ? {display: "grid"} : {}}>

        {logo_invertido ? <img
            src={`${
              window.hybrid
                ? "./"
                : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
            }${projectLogo}`}
            alt=""
          /> : null}
          {projectLogosMultiples.length > 0 ? (
            <div style={{display: "flex"}}>
              <img
                src={`${
                  window.hybrid
                    ? "./"
                    : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                }${builderLogo}`}
                alt=""
              />
              {projectLogosMultiples.map((item: any) => (
                <img
                  src={`${
                    window.hybrid
                      ? "./"
                      : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
                  }${item.link}`}
                  alt=""
                />
              ))}
            </div>
          ) : null}
          {projectLogosMultiples.length === 0 && active_builder_logo ? (
            <img
              src={`${
                window.hybrid
                  ? "./"
                  : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
              }${builderLogo}`}
              alt=""
            />
          ) : null}
          {!logo_invertido ? <img
            src={`${
              window.hybrid
                ? "./"
                : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"
            }${projectLogo}`}
            alt=""
          /> : null}
        </div>
        <div className="contacto-modal-col-right">
          {data.map((e) => (
            <>
              <div className="contacto-modal-col-right-title">{e.name}</div>
              <div className="contacto-modal-col-right-location">
                <img src="./UI/contacto/location.svg" alt="" />
                {e.location}
              </div>
              <div className="contacto-modal-col-right-horarios">
                <strong>Horario de atención</strong>
                {e.hours.map((h) => (
                  <>
                    <div>{h.dias}</div>
                    <div>
                      {h.hour_from} {h.hour_to}
                    </div>
                  </>
                ))}
              </div>
              {e.emails.length > 0 ? (
                <div className="contacto-modal-col-right-email">
                  <div className="contacto-modal-col-right-email-sub">
                    <img src="./UI/contacto/mail.svg" alt="" />
                    <strong>Correos Electrónicos</strong>
                  </div>
                  {e.emails.map((h) => (
                    <div> {h.email}</div>
                  ))}
                </div>
              ) : null}
              <div className="contacto-modal-col-right-map">
                <img src="./UI/contacto/map.svg" alt="" />
                <a
                  href={e.URLMaps}
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = darkenColor(
                      colors?.main_buttons,
                      0
                    );
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = "";
                  }}
                >
                  Planea cómo llegar - <strong>Google Maps</strong>
                </a>
              </div>
              <div className="contacto-modal-col-right-map">
                <img src="./UI/contacto/waze.svg" alt="" />
                <a
                  href={e.URLWaze}
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = darkenColor(
                      colors?.main_buttons,
                      0
                    );
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = "";
                  }}
                >
                  Planea cómo llegar - <strong>Waze</strong>
                </a>
              </div>
              {e.phones.length > 0 ? (
                <div className="contacto-modal-col-right-phone">
                  <div className="contacto-modal-col-right-phone-sub">
                    <img src="./UI/contacto/phone.svg" alt="" />
                    <strong>Teléfonos</strong>
                  </div>
                  {e.phones.map((h) => (
                    <div> {h.number}</div>
                  ))}
                </div>
              ) : null}
              {e.phones.length > 0 ? (
                <div className="contacto-modal-col-right-phone">
                  <div className="contacto-modal-col-right-phone-sub">
                    <img src="./UI/contacto/wp.svg" alt="" />
                    <strong>Whatsapp</strong>
                  </div>
                  {e.phones.map((h) => (
                    <a
                      href={`https://wa.me/${h.number}?text=Hello,%20I%20am%20interested%20in%20your%20services`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onMouseOver={(e) => {
                        e.currentTarget.style.color = darkenColor(
                          colors?.main_buttons,
                          0
                        );
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.color = "";
                      }}
                    >
                      {h.number}
                    </a>
                  ))}
                </div>
              ) : null}
            </>
          ))}
        </div>
      </div>
    </div>
  );
}
